const { getTranslationDictionary } = require('core');

module.exports = function getCountText(amount) {
	const translationDictionary = getTranslationDictionary();
	const propertyName = `result${amount !== 1 ? 's' : ''}`;
    return `${amount} ${translationDictionary[propertyName]}`;
};
